import { render, staticRenderFns } from "./CategoryPerformance.vue?vue&type=template&id=2721f950&scoped=true&"
import script from "./CategoryPerformance.vue?vue&type=script&lang=js&"
export * from "./CategoryPerformance.vue?vue&type=script&lang=js&"
import style0 from "./CategoryPerformance.vue?vue&type=style&index=0&id=2721f950&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2721f950",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCol,VDataTable,VRow,VSelect,VSpacer,VToolbar})
